function scrollHeroIcons() {
  const icons = [
    "/assets/images/instagram.png",
    "/assets/images/twitter.png",
    "/assets/images/whatsapp.png",
    "/assets/images/tik-tok.png",
    "/assets/images/facebook.png"
  ];

  let currentIconIndex = 0;
  let lastTime = 0;
  const delay = 100; // delay in milliseconds

  $('.hero').mousemove(function (e) {
    const currentTime = new Date().getTime();
    if (currentTime - lastTime >= delay) {
        lastTime = currentTime;

        const iconImage = icons[currentIconIndex];
        const $icon = $('<img class="icon">').attr('src', iconImage).css({
            left: (e.pageX - 32) + 'px', // Adjust for icon width/2
            top: (e.pageY - 32) + 'px' // Adjust for icon height/2
        });

        $('body').append($icon);

        setTimeout(() => {
          $icon.css('opacity', 1);
        }, 10); // Small delay to trigger the CSS transition

        setTimeout(() => {
            $icon.css('opacity', 0);
            setTimeout(() => $icon.remove(), 500);
        }, 500);

        currentIconIndex = (currentIconIndex + 1) < icons.length ? currentIconIndex + 1 : 0;
    }
  });
}
scrollHeroIcons();